/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Shipping_item = {
    readonly " $fragmentRefs": FragmentRefs<"freeShippingHelpers_item">;
    readonly " $refType": "Shipping_item";
};
export type Shipping_item$data = Shipping_item;
export type Shipping_item$key = {
    readonly " $data"?: Shipping_item$data;
    readonly " $fragmentRefs": FragmentRefs<"Shipping_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Shipping_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "freeShippingHelpers_item",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "vertical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuotes",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isComplimentary",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "totalAmount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "serviceMethod",
              "storageKey": null,
              "args": null,
              "concreteType": "ShipmentServiceMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "region",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Region",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "regionName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '5583fd318914680432c37424f204d7d4';
export default node;
